import React from 'react';

export default ({ color })=>(
	<svg id="Capa_1" style={{"enableBackground":"new 0 0 28.421 28.421"}} version="1.1" viewBox="0 0 28.421 28.421" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" xmlSpace="preserve" fill={color}>
		<g>
			<path d="M9.035,13.624c0,0.685-0.555,1.24-1.24,1.24s-1.24-0.555-1.24-1.24c0-0.685,0.555-1.24,1.24-1.24&#xD;&#xA;&#x9;&#x9;S9.035,12.939,9.035,13.624z M15.695,12.358c-0.685,0-1.24,0.555-1.24,1.24c0,0.685,0.555,1.24,1.24,1.24&#xD;&#xA;&#x9;&#x9;c0.685,0,1.24-0.555,1.24-1.24S16.38,12.358,15.695,12.358z M22.78,15.774l-1.057,0.01l0.012,2.964&#xD;&#xA;&#x9;&#x9;c0,1.406-1.551,1.455-1.551,1.455L4.021,20.196c-1.455,0-1.722-1.682-1.722-1.682V8.79C0.463,7.42,0.553,5.291,0.553,5.291&#xD;&#xA;&#x9;&#x9;c0-5.546,4.883-5.248,4.883-5.248c5.337-0.21,5.127,5.309,5.127,5.309C10.563,0.225,15.481,0,15.481,0&#xD;&#xA;&#x9;&#x9;c5.546,0,5.177,5.399,5.177,5.399L20.68,6.17c1.256,0,1.008,1.654,1.008,1.654l-0.012,0.951l1.037,0.007l5.146-2.533l0.009,12.386&#xD;&#xA;&#x9;&#x9;L22.78,15.774z M5.812,7.941c0.453,0,1.047-0.017,1.047-0.017h7.407c0,0,0.731,0.017,1.184,0.017c1.495,0,2.654-1.033,2.654-2.529&#xD;&#xA;&#x9;&#x9;c0-1.499-1.131-2.766-2.628-2.766S12.79,3.86,12.79,5.355c0,0.411-0.018,0.443,0.142,0.789H8.221&#xD;&#xA;&#x9;&#x9;C8.383,5.798,8.416,5.74,8.416,5.329c0-1.499-1.189-2.684-2.685-2.684c-1.497,0-2.546,1.267-2.546,2.766&#xD;&#xA;&#x9;&#x9;C3.185,6.907,4.316,7.94,5.812,7.941z M10.886,13.637c0-1.715-1.364-3.106-3.078-3.106s-3.105,1.391-3.105,3.106&#xD;&#xA;&#x9;&#x9;s1.39,3.078,3.105,3.078S10.886,15.352,10.886,13.637z M18.773,13.637c0-1.715-1.364-3.106-3.077-3.106s-3.104,1.391-3.104,3.106&#xD;&#xA;&#x9;&#x9;s1.39,3.078,3.104,3.078S18.773,15.352,18.773,13.637z M12.652,22.554h4.285v-1.826H7.238v1.826h4.131l0.03,0.031l-5.835,5.836&#xD;&#xA;&#x9;&#x9;h1.222l4.77-4.77v4.77h0.863v-4.816l4.817,4.816l1.217-0.005l-5.832-5.831L12.652,22.554z"/>
		</g>
		<g/>
		<g/>
		<g/>
		<g/>
		<g/>
		<g/>
		<g/>
		<g/>
		<g/>
		<g/>
		<g/>
		<g/>
		<g/>
		<g/>
		<g/>
	</svg>
	);


// WEBPACK FOOTER //
// ./src/components/sidebar/iconsvgs/projects.js